import * as React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";

// Icons
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import AccountBalanceWalletRoundedIcon from "@mui/icons-material/AccountBalanceWalletRounded";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import BarChartRoundedIcon from "@mui/icons-material/BarChartRounded";
import PieChartRoundedIcon from "@mui/icons-material/PieChartRounded";
import SavingsRoundedIcon from "@mui/icons-material/SavingsRounded";
import GroupRoundedIcon from "@mui/icons-material/GroupRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import HelpRoundedIcon from "@mui/icons-material/HelpRounded";

const mainListItems = [
  { text: "Dashboard", icon: <HomeRoundedIcon />, path: "/" },
  { text: "Transactions", icon: <ReceiptLongRoundedIcon />, path: "/transactions" },
  { text: "Accounts", icon: <AccountBalanceWalletRoundedIcon />, path: "/accounts" },
  { text: "Budget", icon: <PieChartRoundedIcon />, path: "/budget" },
  { text: "Money Jars", icon: <SavingsRoundedIcon />, path: "/jars" },
  { text: "Reports", icon: <BarChartRoundedIcon />, path: "/reports" },
];

const secondaryListItems = [
  { text: "Settings", icon: <SettingsRoundedIcon />, path: "/settings" },
  { text: "About", icon: <InfoRoundedIcon />, path: "/about" },
  { text: "Help", icon: <HelpRoundedIcon />, path: "/help" },
];

export default function MenuContent() {
  const navigate = useNavigate();
  const location = useLocation();

  const renderList = (items: { text: string; icon: React.ReactNode; path: string }[]) =>
    items.map((item) => (
      <ListItem key={item.text} disablePadding sx={{ display: "block", px: 1, mb: 0.5 }}>
        <ListItemButton
          selected={location.pathname === item.path}
          onClick={() => navigate(item.path)}
          sx={{ py: 1, px: 1.5 }}
        >
          <ListItemIcon sx={{ minWidth: 40 }}>{item.icon}</ListItemIcon>
          <ListItemText
            primary={item.text}
            primaryTypographyProps={{ fontSize: '0.875rem', fontWeight: 500 }}
          />
        </ListItemButton>
      </ListItem>
    ));

  return (
    <Stack sx={{ flexGrow: 1, px: 1.5, py: 1, justifyContent: "space-between" }}>
      <List dense>{renderList(mainListItems)}</List>
    </Stack>
  );
}
